// ** Initial State
const initialState = {
  data: [],
  paginationMeta: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
};

const nextStatuses = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_NEXT_STATUSES':
    return {
      ...state,
      data: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };
  default:
    return { ...state };
  }
};
export default nextStatuses;
